(function() {
  const AUDIO_SRC = window.spiritedAudioSrc;
  const STORAGE_KEY = 'spirited_music_state';
  const TIME_KEY = 'spirited_music_time';

  if (!AUDIO_SRC) {
    console.error('Spirited audio: no source defined');
    return;
  }

  // Build audio element with explicit type
  const audio = new Audio();
  audio.src = AUDIO_SRC;
  audio.loop = true;
  audio.preload = 'auto';
  audio.volume = 0.35;
  audio.crossOrigin = 'anonymous';

  // Debug: log loading state
  audio.addEventListener('loadeddata', () => console.log('Spirited audio: loaded'));
  audio.addEventListener('error', (e) => {
    console.error('Spirited audio error:', audio.error?.code, audio.error?.message, AUDIO_SRC);
  });
  audio.addEventListener('canplay', () => console.log('Spirited audio: can play'));

  const savedState = sessionStorage.getItem(STORAGE_KEY);
  const wasPlaying = savedState === 'playing';
  const savedTime = parseFloat(sessionStorage.getItem(TIME_KEY) || '0');

  audio.addEventListener('loadedmetadata', () => {
    if (savedTime > 0 && savedTime < audio.duration) {
      audio.currentTime = savedTime;
    }
    if (wasPlaying) {
      audio.play().catch(() => {
        sessionStorage.setItem(STORAGE_KEY, 'paused');
        updateToggleUI(false);
      });
    }
  });

  setInterval(() => {
    if (!audio.paused) {
      sessionStorage.setItem(TIME_KEY, audio.currentTime.toString());
    }
  }, 1000);

  function updateToggleUI(playing) {
    const toggle = document.getElementById('spirited-music-toggle');
    if (!toggle) return;
    toggle.classList.toggle('is-playing', playing);
    toggle.setAttribute('aria-label', playing ? 'Pause music' : 'Play music');
  }

  function toggleMusic() {
    if (audio.paused) {
      audio.play().then(() => {
        sessionStorage.setItem(STORAGE_KEY, 'playing');
        updateToggleUI(true);
      }).catch(err => {
        console.warn('Spirited audio playback failed:', err);
        alert('Audio failed to play. Check browser console for details.');
      });
    } else {
      audio.pause();
      sessionStorage.setItem(STORAGE_KEY, 'paused');
      updateToggleUI(false);
    }
  }

  function init() {
    const toggle = document.getElementById('spirited-music-toggle');
    if (toggle) {
      toggle.addEventListener('click', toggleMusic);
      updateToggleUI(!audio.paused);
    }

    if (!savedState) {
      showPrompt();
    }
  }

  function showPrompt() {
    const prompt = document.createElement('button');
    prompt.id = 'spirited-music-prompt';
    prompt.innerHTML = '<span class="note">♪</span> Play music';
    prompt.setAttribute('aria-label', 'Play ambient music');
    document.body.appendChild(prompt);

    setTimeout(() => prompt.classList.add('is-visible'), 1000);

    let fadeTimer = setTimeout(() => {
      prompt.classList.remove('is-visible');
      setTimeout(() => prompt.remove(), 600);
    }, 6000);

    prompt.addEventListener('click', () => {
      clearTimeout(fadeTimer);
      audio.play().then(() => {
        sessionStorage.setItem(STORAGE_KEY, 'playing');
        updateToggleUI(true);
      }).catch(err => {
        console.warn('Spirited audio prompt playback failed:', err);
      });
      prompt.classList.remove('is-visible');
      setTimeout(() => prompt.remove(), 600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();